import {Link} from "react-router-dom";

export default function GenericOrgViewMoreBtn({to = ""}) {
    return (
        <Link className="flex items-center justify-center space-x-2 font-black hover:underline" to={to}>
            <span>View More</span>
            <img src="/assets/images/gen-org-view.png" alt="" width={24} height={24}/>
        </Link>
    )
}